import {FaGlobe,FaSalesforce,FaShieldAlt} from "react-icons/fa";

// Features Data
export const featuresData = [
  {
    id: 1,
    icon:<FaGlobe/>,
    title: "Virtusa Full Stack",
    des: "Website for nameboard gifts where customers can browse and purchase nameboards directly from the website.",
  },
  {
    id: 2,
    icon: <FaSalesforce/>,
    title: "Salesforce",
    des: "Here we developed applications on the Salesforce platform. It is a cloud-based platform that allows to manage customer data.",
  },
  {
    id: 3,
    icon: <FaShieldAlt />,
    title: "AICTE Internship",
    des: "It is an Virtual internship of Cybersecurity where I learnt Introduction and fundamentals of Cloud and Cyber security.",
  },
];